/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './config/i18n-config';
export * from './config/i18n-config-initializer';
export * from './date.pipe';
export * from './numeric.pipe';
export { I18nModule } from './i18n.module';
export * from './i18next/index';
export * from './testing/index';
export * from './translatable';
export * from './translate.pipe';
export * from './translation-chunk.service';
export * from './translation-resources';
export * from './translation.service';
